module.exports = __webpack_public_path__ + "img/icons B_8.3090cea5.png";